import { useEffect, useState, useRef } from "react";
import { adSizes } from "./adSlotsSizes";
import { logs } from "./fetch";
import useSessionStore from "../Lib/Context";
import ReactGA from "react-ga4";
import { loadPrebidScript, requestBidsAndRefresh } from "./prebid-manager";

const googletag = window.googletag || (window.googletag = { cmd: [] });
// const stpd = window.stpd || { que: [] };

let adSlots = {};

export function getAdSlots() {
  return adSlots;
}

function filterObjectKeys(obj, allowedKeys) {
  return Object.keys(obj).reduce((filteredObj, key) => {
    if (allowedKeys.includes(key)) {
      filteredObj[key] = obj[key];
    }
    return filteredObj;
  }, {});
}

function cleanAdUnitPath(adUnitPath) {
  var result = adUnitPath.split("/");
  return result[3];
}

export function GPTEventTracking(data) {
  googletag.cmd.push(() => {
    googletag.pubads().addEventListener("slotOnload", (event) => {
      var elementPath = event.slot.getAdUnitPath();
      var slotId = cleanAdUnitPath(elementPath);
      if (slotId === "video_pri" || slotId === "video_sec") {
        console.log("video slot onload");
      }

      var onloadEvents = {
        sessionID: data.sessionID,
        event: "slotOnload",
        slotID: slotId,
        serviceName: "thinkzone",
        slot: slotId,
      };
      logs(onloadEvents, data);
    });
    // googletag.pubads().addEventListener("impressionViewable", function (event) {
    //   var elementPath = event.slot.getAdUnitPath();
    //   var slotId = cleanAdUnitPath(elementPath);
    //   var Impressiondetails = {
    //     sessionID: data.sessionID,
    //     event: "impressionViewable",
    //     slotID: slotId,
    //     serviceName: "thinkzone",
    //     slot: slotId,
    //   };
    //   logs(Impressiondetails, data);
    // });

    googletag.pubads().addEventListener("slotRenderEnded", function (event) {
      var elementPath = event.slot.getAdUnitPath();
      var slotId = cleanAdUnitPath(elementPath);

      var details = {
        sessionID: data.sessionID,
        event: "slotRenderEnded",
        slotID: slotId,
        slot: slotId,
        serviceName: "thinkzone",
        advertiserId: event.advertiserId,
        campaignId: event.campaignId,
        companyId: event.companyIds,
        "isBackfill?": event.isBackfill,
        "isEmpty?": event.isEmpty,
        labelIDs: event.labelIds,
        lineItemId: event.lineItemId,
        size: event.size,
        "slotContentChanged?": event.slotContentChanged,
        sourceAgnosticCreativeId: event.sourceAgnosticCreativeId,
        sourceAgnosticLineItemId: event.sourceAgnosticLineItemId,
        yieldGroupId: event.yieldGroupIds,
      };

      logs(details, data);
    });

    googletag.pubads().addEventListener("slotRequested", function (event) {
      var elementPath = event.slot.getAdUnitPath();
      var slotId = cleanAdUnitPath(elementPath);

      var requestEvents = {
        sessionID: data.sessionID,
        event: "slotRequested",
        slotID: slotId,
        serviceName: "thinkzone",
        slot: slotId,
      };

      logs(requestEvents, data);
    });

    googletag
      .pubads()
      .addEventListener("slotResponseReceived", function (event) {
        var elementPath = event.slot.getAdUnitPath();
        var slotId = cleanAdUnitPath(elementPath);

        var receivedEvents = {
          sessionID: data.sessionID,
          event: "slotResponseReceived",
          slotID: slotId,
          serviceName: "thinkzone",
          slot: slotId,
        };
        logs(receivedEvents, data);
      });
  });
}

export const InitializeAds = () => {
  const [isApiReady, setIsApiReady] = useState(false);
  useEffect(() => {
    const script = document.createElement("script");
    const script2 = document.createElement("script");
    script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
    // script2.src = "https://stpd.cloud/saas/10063";
    script.async = true;
    script2.async = true;
    // script.defer = true;
    script.crossOrigin = "anonymous";
    // script2.crossOrigin = "anonymous";

    document.head.appendChild(script);
    // document.head.appendChild(script2);

    script.onload = () => {
      //GPTEventTracking(data)
      googletag.cmd.push(() => {
        // Global GPT configuration
        googletag.setConfig({
          adsenseAttributes: { page_url: "https://thinkwifizone.com" },
          videoAds: { enableVideoAds: true }
        });

        // Disable initial load, to precisely control when ads are requested.
        googletag.pubads().disableInitialLoad();

        // Enable SRA and services.
        //googletag.pubads().enableSingleRequest();
        googletag.enableServices();

        setIsApiReady(true);
      });
      googletag.cmd.push(() => {
        console.log("destroying all slots");
        googletag.destroySlots();
      });
      // Load Prebid.js in parallel (fire-and-forget, non-blocking)
      loadPrebidScript();
    };
    // script2.onload = () => {
    //   stpd.que.push(function () {
    //     stpd.initialize();
    //   });
    // };
    return () => {
      // Clean up if needed (e.g., remove script element)
    };
  }, []);
  return isApiReady;
};

export const EnableRewardedVideo = (AdUnit) => {
  const [isRewardedReady, setisRewarded] = useState(false);
  const [isRewardGranted, setisRewardGranted] = useState(false);
  const [videoErrorState, setVideoErrorState] = useState(false);
  const [VideoHasFailed, setVideoHasFailed] = useState(false);
  const [isVideoViewable, setIsVideoViewable] = useState(false);
  const { SessionData, setSessionData } = useSessionStore();
  const Fallback = false

  useEffect(() => {
    // Ensure GPT is available
    // if (window.googletag && googletag.apiReady) {
    if (Fallback){
      // if (AdUnit.adUnit === "video_sec") {
      //   googletag.cmd.push(() => {
      //     console.log("destroying all slots");
      //     googletag.destroySlots();
      //   });
      // }
      // Define the ad slot for an out-of-page rewarded video
      let adUnitParent = SessionData.adUnitCode;
      let rewardedAdIsReady = false;

      googletag.cmd.push(() => {
        // Create a new out-of-page ad slot for the rewarded video
        const rewardedSlot = googletag.defineOutOfPageSlot(
          `${adUnitParent}video_pri`,
          googletag.enums.OutOfPageFormat.REWARDED
        );
        // const rewardedSlot = googletag.defineOutOfPageSlot(
        //   `${adUnitParent}${AdUnit.adUnit}`,
        //   googletag.enums.OutOfPageFormat.REWARDED
        // );
        // Make sure the slot was created successfully
        if (rewardedSlot) {
          setIsVideoViewable(false);
          if (AdUnit.adUnit === "video_pri") {
            Object.keys(SessionData.AdUnitTargeting.video_pri).map((key) =>
              rewardedSlot.setTargeting(
                key,
                SessionData.AdUnitTargeting.video_pri[key]
              )
            );
          } else if (AdUnit.adUnit === "video_sec") {
            Object.keys(SessionData.AdUnitTargeting.video_pri).map((key) =>
              rewardedSlot.setTargeting(
                key,
                SessionData.AdUnitTargeting.video_pri[key]
              )
            );
          }
          rewardedSlot.addService(googletag.pubads());

          googletag.pubads().addEventListener("rewardedSlotReady", (event) => {
            var elementPath = event.slot.getAdUnitPath();
            let slotId = cleanAdUnitPath(elementPath);
            console.log("rewarded slot is really active")
            // rewardedAdIsReady = true;
            let Impressiondetails = {
              sessionID: SessionData.sessionID,
              event: "rewardedSlotReady",
              slotID: slotId,
              serviceName: "thinkzone",
              slot: slotId,
              payload: 1,
            };
            logs(Impressiondetails, SessionData);
          
              ReactGA.event("rewardedSlotReady", {
                AdEvent: "rewardedSlotReady",
              });
            // event.makeRewardedVisible();
            setisRewarded(event);
          });
          googletag
            .pubads()
            .addEventListener("impressionViewable", function (event) {
              var elementPath = event.slot.getAdUnitPath();
              var slotId = cleanAdUnitPath(elementPath);
              if (slotId === "video_pri" || slotId === "video_pri_bck") {
                console.log("video imprssions" + slotId);
                setIsVideoViewable(true);
                if (AdUnit.adUnit === "video_pri") {
                  ReactGA.event("impressionViewable", {
                    AdEvent: "impressionViewable",
                  });
                }

                console.log(slotId);
              } 

              // var Impressiondetails = {
              //   sessionID: data.sessionID,
              //   event: "impressionViewable",
              //   slotID: slotId,
              //   serviceName: "thinkzone",
              //   slot: slotId,
              // };
              // logs(Impressiondetails, data);
            });
          // Listen for events like when the ad is closed or viewed
          googletag
            .pubads()
            .addEventListener("rewardedSlotClosed", function (event) {
              var elementPath = event.slot.getAdUnitPath();
              let slotId = cleanAdUnitPath(elementPath);
              let Impressiondetails = {
                sessionID: SessionData.sessionID,
                event: "rewardedSlotClosed",
                slotID: slotId,
                serviceName: "thinkzone",
                slot: slotId,
                payload: 1,
              };
              logs(Impressiondetails, SessionData);
                ReactGA.event("rewardedSlotClosed", {
                  AdEvent: "rewardedSlotClosed",
                });
    
              setTimeout(() => {
                setVideoErrorState(true);
              }, 500);
            });

          googletag
            .pubads()
            .addEventListener("rewardedSlotGranted", function (event) {
              var elementPath = event.slot.getAdUnitPath();
              let slotId = cleanAdUnitPath(elementPath);
              let Impressiondetails = {
                sessionID: SessionData.sessionID,
                event: "rewardedSlotGranted",
                slotID: slotId,
                serviceName: "thinkzone",
                slot: slotId,
                payload: 1,
              };
              logs(Impressiondetails, SessionData);
                ReactGA.event("rewardedSlotGranted", {
                  AdEvent: "rewardedSlotGranted",
                });
              setisRewardGranted(true);
              setTimeout(() => {
                dismissRewardedAd();
              }, 3000);
            });
          googletag.display(rewardedSlot);
          googletag.pubads().refresh([rewardedSlot]);
          // refreshRewardedAd();
        } else {
          console.log("Rewarded ads are not supported on this page.");
        }

        function refreshRewardedAd() {
          setTimeout(() => {
            if (!rewardedAdIsReady) {
              console.log("Video ad has failed");
              console.log("refreshing video ad");
              // dismissRewardedAd();
              setVideoHasFailed(true);
              // window.location.reload();
              //googletag.pubads().refresh([rewardedSlot]);
            }
          }, 4000);
        }

        function dismissRewardedAd() {
          googletag.cmd.push(() => {
            googletag.destroySlots([rewardedSlot]);
          });
        }
      });
    }
  }, []);

  return [
    isRewardedReady,
    isRewardGranted,
    videoErrorState,
    VideoHasFailed,
    isVideoViewable,
  ];
};

export function EnableAdUnits(AdSlot) {
  // let stpd = window.stpd || { que: [] };
  useEffect(() => {
    const slotId = AdSlot.Name;
    const adUnit = `${AdSlot.Network}${AdSlot.Name}`;
    const Targeting = AdSlot.Targeting;
    googletag.cmd.push(() => {
      const slot = googletag.defineSlot(adUnit, adSizes[AdSlot.Name], slotId);
      if (slot) {
        Object.keys(Targeting).map((key) =>
          slot.setTargeting(key, Targeting[key])
        );
        slot.addService(googletag.pubads());
        googletag.display(slot);
        adSlots[slotId] = slot;
      }
    });

    return () => {
      googletag.cmd.push(() => {
        if (adSlots[slotId]) {
          googletag.destroySlots([adSlots[slotId]]);
          // stpd.terminateAdunit(adSlots[slotId]);
          delete adSlots[slotId];
        }
      });
    };
  }, []);

  return (
    <div>
      <div id={AdSlot.Name}></div>
    </div>
  );
}

export function ClearAds(clearList) {
  // let stpd = window.stpd || { que: [] };
  googletag.cmd.push(() => {
    clearList.forEach((value) => {
      if (adSlots[value]) {
        googletag.destroySlots([adSlots[value]]);
        // stpd.terminateAdunit(adSlots[value]);
        // stpd.removeAdUnit(adSlots[value]);
        delete adSlots[value];
      }
    });
  });
}

// export const LoadAds = (AdsToReload) => {
//   let stpd = window.stpd || { que: [] };
//   useEffect(() => {
//     const allowedKeys = AdsToReload.Ads;
//     const refreshAds = filterObjectKeys(adSlots, allowedKeys);
//     if (AdsToReload.Vendor === "mikrotik") {
//       if (AdsToReload.Reload) {
//         stpd.refreshAdUnit(allowedKeys[0]);
//       } else {
//         stpd.initialize(allowedKeys[0]);
//       }
//     } else {
//       googletag.cmd.push(() => {
//         const slots = Object.values(refreshAds);
//         googletag.pubads().refresh(slots);
//       });
//     }
//   }, []);
// };

export const LoadAds = (AdsToReload) => {
  useEffect(() => {
    const allowedKeys = AdsToReload.Ads;
    const refreshAds = filterObjectKeys(adSlots, allowedKeys);
    console.log(refreshAds);
    googletag.cmd.push(() => {
      const slots = Object.values(refreshAds);
      console.log(slots);
      googletag.pubads().refresh(slots);
    });
  }, []);
};

export const LoadAdsPB = (AdsToReload) => {
  const { SessionData } = useSessionStore();
  useEffect(() => {
    const allowedKeys = AdsToReload.Ads;
    const refreshAds = filterObjectKeys(adSlots, allowedKeys);
    const gptSlots = Object.values(refreshAds);
    if (gptSlots.length > 0) {
      requestBidsAndRefresh(
        allowedKeys,
        gptSlots,
        SessionData.adUnitCode,
        SessionData
      );
    }
  }, []);
};
